import {USMapType} from './USMapType';
import * as d3 from 'd3';
import USElectionData from "../data/USElectionData";
import {StateElectionDataEntry} from "../data/StateElectionDataEntry";

class USMapState {
    mapType: USMapType = USMapType.GEOGRAPHIC;
    year: number;
    data: USElectionData;

    private static readonly MIN_CIRCLE_SIZE: number = 20;
    private static readonly MAX_CIRCLE_SIZE: number = 40;

    constructor(year: number, usElectionData: USElectionData) {
        this.year = year;
        this.data = usElectionData;
    }

    public setMapType(mapType: USMapType): void {
        this.mapType = mapType;
    }

    private getTotalElectoralVotes(state: keyof StateElectionDataEntry): number {
        const electionData = this.data.getStateElectionData(state);
        return electionData.dem_electoral_votes + electionData.rep_electoral_votes;
    }

    private getVoterImpact(state: keyof StateElectionDataEntry): number {
        const electionData = this.data.getStateElectionData(state);
        return 1 / electionData.num_voters_per_electoral_vote;
    }

    public getCircleRadius(us_state_name: keyof StateElectionDataEntry): number {
        let min: number;
        let max: number;
        let getValue: (state: keyof StateElectionDataEntry) => number;

        switch(this.mapType) {
            case USMapType.DORLING_VOTER_IMPACT:
                getValue = this.getVoterImpact.bind(this);
                break;
            case USMapType.DORLING_ELECTORAL_COLLEGE_SIZE:
                getValue = this.getTotalElectoralVotes.bind(this);
                break;
            default:
                getValue = (state) => this.data.getStateElectionData(state).total_votes;
        }

        const allValues = Object.keys(this.data.data)
            .map(getValue as any)
            .filter(value => typeof value === 'number') as number[];

        allValues.pop();

        //TODO: this should be precomputed
        min = Math.min(...allValues);
        max = Math.max(...allValues);

        let radius = d3.scaleLinear()
            .domain([min, max])
            .range(this.mapType === USMapType.DORLING_ELECTORAL_COLLEGE_SIZE
                ? [USMapState.MIN_CIRCLE_SIZE, USMapState.MAX_CIRCLE_SIZE]
                : [USMapState.MIN_CIRCLE_SIZE, USMapState.MAX_CIRCLE_SIZE])
            .clamp(true);
        return radius(getValue(us_state_name));
    }
}

export default USMapState;